import React, { useState } from 'react';

import { useToast } from '@chakra-ui/react';

import { deleteOrders, fetchOrders } from 'api/order';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { washHub } from 'store/slices';
import { useWashHubListener } from 'hooks';

import { Status } from 'types/items';
import { RequestsProps } from './Requests.props';

import RequestsView from './Requests.view';

const OrdersContainer = (_: RequestsProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const [page, setPage] = useState<number>(1);

  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [`${washHubId}-fetch-orders`, page, Status.CUSTOMER_REQUEST];

  const queryFn = () =>
    fetchOrders({
      page,
      limit: 10,
      washHub: washHubId,
      status: Status.CUSTOMER_REQUEST,
    });

  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  const { data, isLoading, isFetching } = useQuery(queryKey, queryFn, options);

  const { mutate, isLoading: isDeleting } = useMutation(deleteOrders);

  useWashHubListener(() => {
    setPage(1);
  });

  const onDelete = (ids: string[], _onSuccess: () => void) =>
    mutate(ids, {
      onSuccess: () => {
        toast({
          status: 'success',
          title: 'Success',
          description: 'Orders Deleted',
          isClosable: true,
          duration: 3000,
        });

        queryClient.invalidateQueries(`${washHubId}-fetch-orders`);

        _onSuccess();
      },
    });

  const orders = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };

  const _props = {
    orders,
    onDelete,
    pagination,
    isDeleting,
    isLoading: isLoading || isFetching,
  };

  return <RequestsView {..._props} />;
};

export default OrdersContainer;
